import React from 'react';

const Users: React.FC = () => {
  return <div>Manage your users here.</div>;
};

export default Users;
